import { Outside } from '@cian/ui-kit';
import * as React from 'react';

import { useMessageErrorMenu } from './hooks/useMessageErrorMenu';
import * as styles from './styles.css';

type TMessageErrorModalType = {
  messageId: string;
  isOfferMessage?: boolean;
  buttonRef: React.RefObject<HTMLButtonElement>;
  closeMenu: () => void;
};

export const MessageErrorMenu: React.VFC<TMessageErrorModalType> = ({
  messageId,
  isOfferMessage = false,
  closeMenu,
  buttonRef,
}) => {
  const menuItems = useMessageErrorMenu(messageId, isOfferMessage);

  const items = React.useMemo(
    () =>
      menuItems.map(({ title, handler }, index) => (
        <li
          key={index}
          data-testid="error-option"
          className={styles['item']}
          onClick={() => {
            handler();
            closeMenu();
          }}
        >
          {title}
        </li>
      )),
    [menuItems, closeMenu],
  );

  return (
    <Outside active insideRefs={[buttonRef]} onOutside={closeMenu}>
      <ul className={styles['menu']} data-testid="error-list" data-name="MessageErrorMenu">
        {items}
      </ul>
    </Outside>
  );
};
